import { useState } from "react";
import Alert from "@shared/v2/Alert";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import TextComboInput from "@shared/v2/TextComboInput";
import Typography from "@shared/v2/Typography";
import format from "@shared/formatters";
import IconButton from "@shared/v2/IconButton";
import { XmarkLargeSolidV6 } from "@shared/v2/Icomoon";
import { useWizardContext } from "./WizardContext";
import { useCurrentUser } from "../../../reducers/layoutReducer/selectors";

const LetsGetStarted = () => {
  const currentUser = useCurrentUser();
  const { year, onClose, currentNetIncomeGoal, setCurrentNetIncomeGoal, formErrors, validateAndNext } =
    useWizardContext();
  const [showAlert, _setShowAlert] = useState(
    localStorage.getItem("goalWizard:showSaveProgressAlert") !== "false",
  );

  const setShowAlert = (value) => {
    _setShowAlert(value);
    localStorage.setItem("goalWizard:showSaveProgressAlert", String(value));
  };

  return (
    <>
      <Modal.Header
        title="Let's Get Started"
        description={
          <div className="tw-flex tw-flex-col tw-gap-[16px]">
            <span>
              Let&apos;s start with how much pretax income you want to take home for the year. That will help
              us calculate your other goals so they are aligned with achieving your desired net income.
            </span>
            <Typography variant="body-s" className="!tw-italic !tw-text-gray-50">
              If you don&apos;t know your exact net income goal yet, go ahead and enter an estimate - you can
              always change it later.
            </Typography>
          </div>
        }
        closeButton
      />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px] tw-overflow-y-auto">
        {showAlert && (
          <Alert
            variant={currentUser.account.isPlace || currentUser.account.isLever ? "info" : "brivity"}
            title="Income Goal & Stats Can Now Be Saved"
            text={
              <div className="tw-flex tw-items-center tw-gap-[8px]">
                <div>
                  Need to take a break while setting your goals? Look for the new <b>Save Progress</b> button.
                  We will also auto-save your progress in between steps.
                </div>
                <IconButton
                  onClick={() => setShowAlert(false)}
                  schema="transparent"
                  className="tw-mb-[20px] !tw-text-inherit tw-flex-none"
                >
                  <XmarkLargeSolidV6 />
                </IconButton>
              </div>
            }
          />
        )}
        <TextComboInput
          isRequired
          leading="$"
          placeholder="0"
          spacing={0}
          value={currentNetIncomeGoal ? format.number(currentNetIncomeGoal, 0) : ""}
          label={`In ${year}, I want to make`}
          onChange={(e) => setCurrentNetIncomeGoal((e.target.value || "").replace(/[^0-9]/g, ""))}
          error={formErrors.currentNetIncomeGoal}
        />
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" onClick={validateAndNext}>
          Calculate Goals
        </Button>
      </Modal.Footer>
    </>
  );
};

export default LetsGetStarted;
